import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { memo } from "react";
import { Box } from "../components/Box";
import { mergeSx } from "../system";
export const StickyFabPlacementHelper = memo(({ offsetTop = 0, offsetBottom = 0, placement = "right", offsetX, sx, ...props }) => (_jsx(Box, { sx: mergeSx({
        position: "sticky",
        width: "100%",
        display: "flex",
        justifyContent: placement === "left" ? "flex-start" : "flex-end",
        paddingLeft: placement === "left" ? offsetX : 0,
        paddingRight: placement === "right" ? offsetX : 0,
        top: offsetTop,
        bottom: offsetBottom,
    }, sx), ...props })));
//# sourceMappingURL=StickyFabPlacementHelper.js.map